import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getSearchSiteMessage = (state) => get(state, 'siteMessage.search');
export const getPropertySiteMessage = (state) => get(state, 'siteMessage.property');
export const getBookingSiteMessage = (state) => get(state, 'siteMessage.booking');

export const getSiteMessage = createSelector(
  [getSearchSiteMessage, getPropertySiteMessage, getBookingSiteMessage],
  (search, property, booking) => ({ search, property, booking }),
);
